import React from 'react'

import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationSection from "../../../../../core/model2/navigation/navigation-section"
import {SettingsItemType} from "../@type"
import MenuSettings_Items from "../settings-menu-items"

type Props = {
    onToggle      : (a: string, b: boolean)=>void
    isManager?    : boolean
    collapseState : any
    navigationSection   : NavigationSection
}

export default function MenuSettingsAccount(props: Props) {

    const onToggle = (isOpen: boolean) => {
        props.onToggle('my-account', isOpen)
    }

    const items: SettingsItemType[] = [
        {
            name        : "My Account",
            icon        : "i5-user",
            url         : "my-account",
            exactUrl    : true,
        },
        {
            name        : "Skin & Layout",
            icon        : "ui5-ico-theme",
            url         : "settings/skin",
        },
        {
            name        : "Navigation",
            icon        : "i5-panel",
            subItems    : [
                {
                    name        : "Navigation Panel",
                    icon        : "i5-panel",
                    url         : "settings/navigation-panel",
                },
                {
                    name        : "Project Navigation",
                    icon        : "i5-navigation-light",
                    url         : "settings/project-navigation",
                },
            ]
        },
        {
            name        : "Switch organization",
            icon        : "i5-open-new-window",
            url         : "select-organization",
        },
    ]

    return (
        <NavigationMenuSection name         = "Account settings"
                               counter      = {items.length}
                               collapsible  = {true}
                               isOpen       = {!props.collapseState.isCollapsed('my-account')}
                               onToggle     = {onToggle} >

            <MenuSettings_Items items               = {items}
                                navigationSection   = {props.navigationSection}/>

        </NavigationMenuSection>
    )
}
